import {
  GET_COURSES,
  ADD_COURSE,
  UPDATE_COURSE,
  DELETE_COURSE,
  REQUEST_COURSE,
  ERROR_XHR
} from '../mutation-types'

import toastr from 'toastr'

const state = {
  all: [],
  error: false
}

const mutations = {
  [GET_COURSES] (state, courses) {
    state.all = courses
  },
  [ADD_COURSE] (state, contact) {
    state.all.push(contact)
    toastr.success('La formation a été créée')
  },
  [UPDATE_COURSE] (state, oldContact, updatedContact) {
    state.all.$remove(oldContact)
    state.all.push(updatedContact)
    toastr.success('La formation a été modifiée')
  },
  [DELETE_COURSE] (state, contact) {
    state.all.$remove(contact)
    toastr.success('La formation a été supprimée')
  },
  [REQUEST_COURSE] (state) {
    state.error = false
  },
  [ERROR_XHR] (state, error) {
    console.log(state)
    console.log(error)
    state.error = true
    toastr.success('Une erreur s\'est produite (courses)')
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/courses.js